import { statusEnum } from "../../../../enums/statusEnum";
import { progressoEnum } from "../enum/Progresso.enum";

export class ProgressoToTimelineTransformer {
  isFaseConcluida(fase) {
    return fase.status.id == statusEnum.CONCLUIDO;
  }

  transform(data) {
    const timeline = [];

    for(let i = 0; i < data.fases.length; i++) {
      const fase = data.fases[i];

      if(!this.isFaseConcluida(fase)) {
        break;
      }

      timeline.push(this.getTimelineConcluida(fase));
    }

    if(data.fases.length == timeline.length) return timeline;
    
    const ordem = data.fases[timeline.length].ordem; 
    for(let i = timeline.length; i < data.fases.length; i++) {
      const fase = data.fases[i];

      if(fase.ordem != ordem) {
        break;
      }

      if(this.isFaseConcluida(fase)) {
        timeline.push(this.getTimelineConcluida(fase))
        continue;
      }

      timeline.push(this.getTimelineEmAndamento(fase));
    }

    if(data.fases.length == timeline.length) return timeline;
    
    return timeline.concat(
      data.fases
        .slice(timeline.length, data.fases.length)
        .map(f => this.isFaseConcluida(f)
          ? this.getTimelineConcluida(f)
          : this.getTimelinePendente(f)
        )
    );
  }

  getTimelineConcluida(fase) {
    if(!fase.notificarConclusao) return this.getTimelineObj(fase, '', progressoEnum.OCULTO_CONCLUIDO);
    const partes = fase.dataConclusao.split('-');
    const dataFormatada = `${partes[2]}/${partes[1]}/${partes[0]}`;
    return this.getTimelineObj(fase, dataFormatada + ' - A fase foi concluída.', progressoEnum.CONCLUIDO);
  }

  getTimelineEmAndamento(fase) {
    if(!fase.notificarConclusao) return this.getTimelineObj(fase, '', progressoEnum.OCULTO_EM_ANDAMENTO);
    return this.getTimelineObj(fase, 'Em andamento.', progressoEnum.EM_ANDAMENTO);
  }

  getTimelinePendente(fase) {
    if(!fase.notificarConclusao) return this.getTimelineObj(fase, '', progressoEnum.OCULTO_PENDENTE);
    return this.getTimelineObj(fase, 'Não iniciada.', progressoEnum.PENDENTE);
  }
 
  getTimelineObj(fase, descricao, progressoEnum) {
    return {
      leftText: fase.nome,
      rightText: descricao,
      icon: {
        name: progressoEnum.getIcon(),
        style: { 'color': progressoEnum.getColor()},
        title: progressoEnum.getTitle() 
      },
      progressoEnum
    }
  }
}

export class TimelineToChartTransformer {
  transform(data) {
    return [
      ['Etapas', 'Quantidade'],
      ['Concluídas', data.filter(f => f.progressoEnum.equals(progressoEnum.CONCLUIDO) || f.progressoEnum.equals(progressoEnum.OCULTO_CONCLUIDO)).length],
      ['Em andamento', data.filter(f => f.progressoEnum.equals(progressoEnum.EM_ANDAMENTO) || f.progressoEnum.equals(progressoEnum.OCULTO_EM_ANDAMENTO)).length],
      ['Pendentes', data.filter(f => f.progressoEnum.equals(progressoEnum.PENDENTE) || f.progressoEnum.equals(progressoEnum.OCULTO_PENDENTE)).length],
    ];
  }
}